import React, { PureComponent } from 'react'
import styled from 'styled-components'
import Waypoint from 'react-waypoint'
import PropTypes from 'prop-types'

import { compareArchiveGroups } from 'features/todolist/utils'
import { getListTotalDuration } from 'features/list/utils'
import container from './container'
import Line from 'features/list/components/line'
import ArchiveListHeader from 'features/list/components/archiveListHeader'
import TaskPanel from 'features/taskPanel'

import { translations } from 'gipsy-misc'

class ArchivePage extends PureComponent {
  static propTypes = {
    completedTasks: PropTypes.object,
    onComplete: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    lastSortKey: PropTypes.string.isRequired,
    onEnterWaypoint: PropTypes.func.isRequired,
    onMarkAllAsRead: PropTypes.func.isRequired,
    highlightIds: PropTypes.array
  }

  render() {
    const {
      completedTasks,
      onComplete,
      onChange,
      onClick,
      lastSortKey,
      onEnterWaypoint,
      onMarkAllAsRead,
      highlightIds
    } = this.props
    const sortedGroups = Object.keys(completedTasks).sort(compareArchiveGroups)
    return (
      <Page id="archive-page">
        {sortedGroups.map(group => {
          const totalDuration = getListTotalDuration(completedTasks[group])
          return (
            <Group key={group}>
              {group === 'updates' ? (
                <ArchiveListHeader
                  group={group}
                  onClick={onMarkAllAsRead}
                  text={translations.list.markAllUpdateAsRead}
                />
              ) : (
                <ArchiveListHeader group={group} totalDuration={totalDuration} />
              )}
              <ListBody className="list-body">
                {completedTasks[group].map(task => {
                  return (
                    <Line
                      key={task.id}
                      hideCompleted={0}
                      item={task}
                      onComplete={onComplete}
                      onChange={onChange}
                      onClick={onClick}
                      hideDraggableCell={true}
                      highlight={highlightIds.indexOf(task.id) !== -1}
                    />
                  )
                })}
              </ListBody>
            </Group>
          )
        })}
        <Waypoint key={lastSortKey} onEnter={onEnterWaypoint} bottomOffset={-50} />
        <TaskPanel />
      </Page>
    )
  }
}

const Page = styled.div`
  margin: auto;
`

const Group = styled.div`
  padding-bottom: 50px;
  padding: 8px;
`

const ListBody = styled.div``

export default container(ArchivePage)



// WEBPACK FOOTER //
// ./src/pages/todolist/archivePage/index.js